import React from 'react'
import { Heading, LayoutPageWrapper } from 'goustouicomponents'
import classnames from 'classnames'
import css from './WorkingAtGousto.module.css'

const WorkingAtGousto = () => (
  <section className={css.wrapper}>
    <LayoutPageWrapper>
      <div className={css.textWrapper}>
        <Heading type="h2" size="fontStyleXL">
          What’s it like working at Gousto?
        </Heading>
        <p className={css.mainText}>
          All of us are responsible for the success of Gousto. Our guiding values - dream, deliver and care - show our
          commitment to innovation, our ambition to hit goals at speed, and our deep respect for the people we work
          with.
        </p>
      </div>
      <div className={css.goustoValuesWrapper}>
        <div className={css.goustoValues}>
          <div className={classnames(css.value, css.dream)}>DREAM</div>
          <p className={css.smallText}>
            We’ve got huge ambition and believe everything is possible - Curious, bold and resilient, we’ve got an
            insatiable appetite to learn and grow.
          </p>
        </div>
        <div className={css.goustoValues}>
          <div className={classnames(css.value, css.deliver)}>DELIVER</div>
          <p className={css.smallText}>
            We work at pace and focus on impact, taking ownership of the solution and raising the bar every step of the
            way.
          </p>
        </div>
        <div className={css.goustoValues}>
          <div className={classnames(css.value, css.care)}>CARE</div>
          <p className={css.smallText}>
            We obsess over our customers, doing the right thing for them and for the planet. We are one team, supporting
            and celebrating one another.
          </p>
        </div>
      </div>
    </LayoutPageWrapper>
  </section>
)

export { WorkingAtGousto }
